import React, { useEffect } from 'react';
import ButtonComponent from '../../Components/ButtonComponent';

/*
This is a component that displays all the information of an button in the edit pop up window when we edit a data element.
At this point we meet button only inside a form data element.
*/
const EditButtonComponent = (props) => {
  const {
    componentId,
    index,
    index2,
    componentsInfo,
    setComponentsInfo,
    rowsComponentsIds,
    setRowsComponentsIds,
    clickedEdit,
    editor,
    infoSummary,
    setInfoSummary,
    initComponentsInfo,
    deleteComps,
    setDeleteComps,
    selectedProject
  } = props;

  const [textButton, setTextButton] = React.useState('Send');
  const [stateMethod, setStateMethod] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [method, setMethod] = React.useState('GET');
  const [target, setTarget] = React.useState('undefined');
  const [targetPageChecked, setTargetPageChecked] = React.useState(false);
  const [href, setHref] = React.useState('');
  const [hrefChecked, setHrefChecked] = React.useState(false);
  const [targets, setTargets] = React.useState();

  const findTargetName = (id) => {
    const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject].pages;

    let pageName = '';

    tempData.forEach((page) => {
      if (page.pageId === id) {
        pageName = page.name;
      }
    });
    return pageName;
  };

  useEffect(() => {
    if (initComponentsInfo === true && componentId !== -1) {
      const domComponents = editor.DomComponents;
      const buttonComponent = domComponents.componentsById[componentId];
      const tempComponentsInfo = [...componentsInfo];
      const tempInfoSummary = [...infoSummary];

      if (buttonComponent !== undefined) {
        const labelButton = buttonComponent.get('content');
        const insideButtonContent = buttonComponent.attributes.components.models[0].get('content');

        if (labelButton === '' && insideButtonContent === '') {
          tempInfoSummary[index2].label = 'Send';
          setTextButton('Send');
          tempComponentsInfo[index].info[index2].label = 'Send';
        } else if (labelButton !== '') {
          if (tempInfoSummary[index2] !== undefined) {
            tempInfoSummary[index2].label = labelButton;
          }
          tempComponentsInfo[index].info[index2].label = labelButton;
          setTextButton(labelButton);
        } else {
          if (tempInfoSummary[index2] !== undefined) {
            tempInfoSummary[index2].label = insideButtonContent;
          }
          tempComponentsInfo[index].info[index2].label = insideButtonContent;
          setTextButton(insideButtonContent);
        }

        if (
          buttonComponent.attributes.attributes.target_page !== undefined &&
          buttonComponent.attributes.attributes.target_page !== 'undefined'
        ) {
          const targetPage = findTargetName(buttonComponent.attributes.attributes.target_page);
          setTarget(targetPage);
          setTargetPageChecked(true);
          tempComponentsInfo[index].info[index2].target_page = targetPage;
        } else {
          setTarget('none');
          setTargetPageChecked(false);
          tempComponentsInfo[index].info[index2].target_page = '';
        }
        if (
          buttonComponent.attributes.attributes.href !== undefined &&
          buttonComponent.attributes.attributes.href !== ''
        ) {
          setHref(buttonComponent.attributes.attributes.href);
          setHrefChecked(true);
          tempComponentsInfo[index].info[index2].href = buttonComponent.attributes.attributes.href;
        } else {
          setHref('');
          if (
            buttonComponent.attributes.attributes.target_page === undefined ||
            buttonComponent.attributes.attributes.target_page === 'undefined'
          ) {
            setHrefChecked(true);
          } else {
            setHrefChecked(false);
          }
          tempComponentsInfo[index].info[index2].href = '';
        }

        if (buttonComponent.attributes.attributes.method !== undefined) {
          setMethod(buttonComponent.attributes.attributes.method);
          tempComponentsInfo[index].info[index2].method =
            buttonComponent.attributes.attributes.method;
        } else {
          tempComponentsInfo[index].info[index2].method = 'GET';
        }

        const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject];
        const tempTargets = [];
        tempData.pages.forEach((page) => {
          tempTargets.push(page.name);
        });
        setTargets(tempTargets);
      }
      setComponentsInfo(tempComponentsInfo);
      setInfoSummary(tempInfoSummary);
    }
  }, [clickedEdit, initComponentsInfo]);

  // This method handles the content of the component button inside an edited form.It changes the value to the pop up edit window and
  const handleTextButton = (val) => {
    const tempInfoSummary = [...infoSummary];
    tempInfoSummary[index2].label = val.target.value;
    setInfoSummary(tempInfoSummary);

    setTextButton(val.target.value);
    const tempComponentsInfo = [...componentsInfo];
    tempComponentsInfo[index].info[index2].label = val.target.value;
    setComponentsInfo(tempComponentsInfo);
  };

  /*
    This function deletes the button component of the edited data form element window and
    of the information about the block that we keep and renders again
    */
  const deleteElement = () => {
    const tempDeleteComps = [...deleteComps];
    tempDeleteComps.push(rowsComponentsIds[index].insideIds[index2]);
    setDeleteComps(tempDeleteComps);

    const tempComponentsInfo = [...componentsInfo];
    tempComponentsInfo[index].div.splice(index2, 1);
    tempComponentsInfo[index].info.splice(index2, 1);
    setComponentsInfo(tempComponentsInfo);

    const tempRowsComponentsIds = [...rowsComponentsIds];
    tempRowsComponentsIds[index].insideIds.splice(index2, 1);
    setRowsComponentsIds(tempRowsComponentsIds);
  };

  /*
    This method adds the selected method to the component button inside and edited form, updates the info in the pop up window
    and closes the menu with the methods options
    */
  const selectMethod = (option) => {
    setAnchorEl(null);
    setStateMethod(false);
    setMethod(option);

    const tempComponentsInfo = [...componentsInfo];
    tempComponentsInfo[index].info[index2].method = option;
    setComponentsInfo(tempComponentsInfo);
  };

  /*
    This function changes the value of target page of button component inside edited form. It enables the state of  target page radio button,
    disables the href radio button and clears href attribute.It also closes the menu with the options of target pages.
    */
  const selectTarget = (option) => {
    setTarget(option);

    const tempComponentsInfo = [...componentsInfo];
    tempComponentsInfo[index].info[index2].target_page = option;
    tempComponentsInfo[index].info[index2].href = '';
    setComponentsInfo(tempComponentsInfo);

    setTargetPageChecked(true);
    setHrefChecked(false);
  };

  /*
    This function controls the radio button of href of button component inside edited form.If it is clicked then it disables the radio
    button of target page, it passes the value of href as an attribute to the button component inside the canvas, and it clears the value
    of target page attribute of the button component inside the canvas
    */
  const handleHrefChecked = () => {
    const tempComponentsInfo = [...componentsInfo];

    if (hrefChecked === false) {
      setHrefChecked(true);
      setTargetPageChecked(false);

      tempComponentsInfo[index].info[index2].href = href;
      tempComponentsInfo[index].info[index2].target_page = 'undefined';
    } else {
      setHrefChecked(false);
      tempComponentsInfo[index].info[index2].href = '';
    }

    setComponentsInfo(tempComponentsInfo);
  };

  /*
    This function changes the value of href of component button inside edited data element. It enables the state of href radio button,
    disables the target page radio button and clears the attribute target page of component button
    */
  const handleHref = (val) => {
    setHref(val.target.value);

    const tempComponentsInfo = [...componentsInfo];
    tempComponentsInfo[index].info[index2].href = val.target.value;
    setHrefChecked(true);
    setTargetPageChecked(false);
    tempComponentsInfo[index].info[index2].target_page = 'undefined';
    setComponentsInfo(tempComponentsInfo);
  };

  /*
    This function controls the radio button of target page of button component inside edited data element. If it is clicked then it
    disables the radio button of href, it passes the value of target page as an attribute to the button component inside the canvas,
    and it clears the value of href attribute of the button component inside the canvas.
    */
  const handleTargetPageChecked = () => {
    const tempComponentsInfo = [...componentsInfo];

    if (targetPageChecked === false) {
      setTargetPageChecked(true);
      setHrefChecked(false);
      tempComponentsInfo[index].info[index2].href = '';
      tempComponentsInfo[index].info[index2].target_page = target;
    } else {
      setTargetPageChecked(false);
      tempComponentsInfo[index].info[index2].target_page = 'undefined';
    }
    setComponentsInfo(tempComponentsInfo);
  };

  return (
      <ButtonComponent
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        deleteComponent={deleteElement}
        handleTextButton={handleTextButton}
        hrefChecked={hrefChecked}
        handleHrefChecked={handleHrefChecked}
        handleHref={handleHref}
        targetPageChecked={targetPageChecked}
        handleTargetPageChecked={handleTargetPageChecked}
        href={href}
        target={target}
        targets={targets}
        textButton={textButton}
        method={method}
        selectMethod={selectMethod}
        selectTarget={selectTarget}
        stateMethod={stateMethod}
        setStateMethod={setStateMethod}
      />
  );
};

export default EditButtonComponent;
